import fetch from "@/utils/request";


export default {
  checkRegister(data?: object): any {
    return fetch({
      url: "/php/api/auth/check_register",
      method: "post",
      data
    });
  },

  register(data?: object): any {
    return fetch({
      url: "/php/api/auth/register",
      method: "post",
      data
    });
  }
};
